var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"print"}},[(!_vm.orders)?_c('Loading'):_vm._l((_vm.orders),function(order){return _c('section',{key:order.id,staticClass:"print-orders"},[_c('order-print-item',{attrs:{"order":order,"settings":_vm.settings}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }